import React, { useRef } from 'react'
import { useSelector } from 'react-redux';
import DatePicker from "react-datepicker";
import useClickOutside from '../../../hooks/useClickOutside';
import classes from "./ExposeNFinalLesson.module.css";
import "react-datepicker/dist/react-datepicker.css";
import './DatePickerExposeNFinalLesson.css';
import BackdropPopup from '../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup';

const DatePickerExposeNFinalLesson = ({ activeFromDate, setActiveFromDate, setShowDatePicker, handleSetCheckedLock }) => {

    const texts = useSelector(state => state.translate.texts);

    const popupRef = useRef(null);

    const filterPassedTime = (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    };

    const update = e => {
        handleSetCheckedLock(e);
        setShowDatePicker(false)
    }

    useClickOutside(popupRef, () => {
        setShowDatePicker(false);
    });

    return (
        <BackdropPopup myHeight='320px' myWidth='240px'>
            <div className={classes.DatePicker} ref={popupRef}>
                <div className={classes.CloseIcon}></div>
                <DatePicker
                    inline
                    selected={activeFromDate}
                    onChange={setActiveFromDate}
                    timeFormat="p"
                    dateFormat="Pp"
                    minDate={new Date()}
                    showTimeInput
                    filterTime={filterPassedTime}
                />
                <button onClick={update} value="lockTill" className={classes.UpdateBtn}>{texts.update}</button>
            </div>
        </BackdropPopup>
    )
}

export default DatePickerExposeNFinalLesson;